// Storage in this browser, for preferences only. It can be unavailable (private mode), so a read gives null then and
// a write is lost: what's chosen only lasts for this session.
export const readStored = (key: string) => {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
};

// Null removes the key.
export const writeStored = (key: string, value: string | null) => {
    try {
        if (value === null) localStorage.removeItem(key);
        else localStorage.setItem(key, value);
    } catch {
        // The value then only lasts for this session.
    }
};
